export const colours = {
    darkTeal: '#00a396',
    darkGrey: '#2e3333',
    lightGrey: '#828585',
    lightTeal: '#00ccbc',
    white: '#ffffff'
};
